import { SliderDesignTokens } from '@primeuix/themes/types/slider';
import componentCommon from '../one-ds-tokens/OneDS-Component-Common.json';
import componentColorScheme from '../one-ds-tokens/OneDS-Component-Color-Scheme.json';
import { t } from '../token-utils';

// https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/slider/index.ts
const sl = componentCommon.slider;
const slCs = componentColorScheme.slider;

export const SliderTelekomDT: SliderDesignTokens = {
  track: {
    background: t(sl.track.background),
    borderRadius: t(sl.track.border.radius),
    size: t(sl.track.size),
  },
  range: {
    background: t(sl.range.background),
  },
  handle: {
    width: t(sl.handle.width),
    height: t(sl.handle.height),
    borderRadius: t(sl.handle.border.radius),
    background: t(sl.handle.background),
    hoverBackground: t(sl.handle.hover.background),
    content: {
      borderRadius: t(sl.handle.content.border.radius),
      hoverBackground: t(sl.handle.content.hover.background),
      width: t(sl.handle.content.width),
      height: t(sl.handle.content.height),
    },
    focusRing: {
      width: t(sl.handle.focus.ring.width),
      offset: t(sl.handle.focus.ring.offset),
      color: t(sl.handle.focus.ring.color),
    },
  },
  colorScheme: {
    light: {
      handle: {
        content: {
          background: t(slCs.handle.content.background),
        },
      },
    },
  },
};
